import React, { createContext, useState, useContext, useEffect, useCallback } from 'react';

const CartContext = createContext();

export const useCart = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error('useCart doit être utilisé dans un CartProvider');
  }
  return context;
};

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState(() => {
    try {
      const saved = localStorage.getItem('cart');
      return saved ? JSON.parse(saved) : [];
    } catch {
      return [];
    }
  });

  // Persister dans localStorage
  useEffect(() => {
    localStorage.setItem('cart', JSON.stringify(cart));
  }, [cart]);

  const addToCart = useCallback((product) => {
    setCart(prev => {
      if (prev.some(item => item.id === product.id)) return prev;
      return [...prev, {
        id: product.id,
        title: product.title,
        price: product.price,
        images: product.images,
        shipping_price: product.shipping_price,
        shipping_available: product.shipping_available,
        local_pickup: product.local_pickup,
        user_id: product.user_id,
        seller_username: product.seller_username,
        city: product.city,
        shippingMethod: product.shipping_available ? 'shipping' : 'pickup'
      }];
    });
  }, []);

  const removeFromCart = useCallback((productId) => {
    setCart(prev => prev.filter(item => item.id !== productId));
  }, []);

  const updateShippingMethod = useCallback((productId, method) => {
    setCart(prev => prev.map(item =>
      item.id === productId ? { ...item, shippingMethod: method } : item
    ));
  }, []);

  const clearCart = useCallback(() => {
    setCart([]);
  }, []);

  const isInCart = useCallback((productId) => {
    return cart.some(item => item.id === productId);
  }, [cart]);

  const getCartCount = useCallback(() => {
    return cart.length;
  }, [cart]);

  const value = {
    cart,
    addToCart,
    removeFromCart,
    updateShippingMethod,
    clearCart,
    isInCart,
    getCartCount
  };

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};
